import { Injectable } from '@angular/core';
import { collection, collectionData, deleteDoc, doc, Firestore, setDoc } from '@angular/fire/firestore';
import { serverTimestamp } from 'src/app/shared-lib/core/db/firestore.models';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { toDate } from 'src/app/shared-lib/core/utils';

@Injectable({
  providedIn: 'root'
})
export class FileDbService {

  constructor(
    private db: Firestore,
  ) { }

  createId() {
    return doc(collection(this.db, '__ids')).id;
  }

  /**
   *
   * @param collectionPath ex:'users/pepe/photo'. where photo is a collection
   * @returns
   */
  create(id, data, collectionPath) {
    data.updatedAt = serverTimestamp();
    data.createdAt = serverTimestamp();
    return setDoc(doc(this.db, `${collectionPath}/${id}`), data);
  }

  delete(file, collectionPath) {
    return deleteDoc(doc(this.db, `${collectionPath}/${file.id}`));
  }

  getAll$(collectionPath): Observable<any[]> {
    return collectionData(collection(this.db, collectionPath), { idField: 'id' }).pipe(
      map(actions => actions.map(a => {
        const data = this.normalize(a);
        return { ...data } as any;
      }))
    );
  }

  normalize(data) {
    data.createdAt = toDate(data.createdAt);
    data.updatedAt = toDate(data.updatedAt);
    return data;
  }
}
